import React from "react";
import { ChevronDown } from "lucide-react";
import type { NavigationItem } from "../types";
import { DesktopDropdownChild } from "./DesktopDropdownChild";

interface DesktopDropdownMoreProps {
  /** Children the user has collapsed out of the up-front list. */
  items: NavigationItem[];
}

/**
 * A labeled, collapsed "More" group at the bottom of a desktop nav dropdown.
 * Holds submenu entries the user chose to hide from the up-front list — they
 * stay one click away rather than disappearing.
 *
 * Built on native <details>/<summary>: no client state, keyboard-accessible,
 * and iPad-safe (tap toggles) per IPAD_TOUCH_INTERACTIONS.
 */
export function DesktopDropdownMore({ items }: DesktopDropdownMoreProps) {
  if (items.length === 0) return null;

  return (
    <details className="group/more mt-1 border-t border-border pt-1 [&[open]_.more-chevron]:rotate-180">
      <summary className="flex items-center justify-between px-4 py-2 text-xs font-medium uppercase tracking-wide text-muted-foreground cursor-pointer select-none hover:bg-accent hover:text-popover-foreground transition-colors min-h-[44px] md:min-h-[48px] list-none [&::-webkit-details-marker]:hidden">
        <span>More ({items.length})</span>
        <ChevronDown className="more-chevron h-4 w-4 transition-transform duration-200" />
      </summary>
      <div className="pt-1">
        {items.map((child) => (
          <DesktopDropdownChild key={child.name} child={child} />
        ))}
      </div>
    </details>
  );
}
